import React from 'react';
import ClickableHelpIcon from 'components/pure/utils/ClickableHelpIcon';
import UserAvatar from 'components/pure/utils/UserAvatar';

import './RepProfileDonutLabel.styl';

export default class RepProfileDonutLabel extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.state = {};
  }
  onMouseEnter() {
    this.setState({hovered: true});
  }
  onMouseLeave() {
    this.setState({hovered: false});
  }
  render() {
    const {rep, percentage, labelText, helpText} = this.props;
    return (
      <div
        className="rep-profile-donut-label"
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}>
        <UserAvatar user={rep} />
        {`${percentage}% of ${labelText}`}
        {this.state.hovered && <ClickableHelpIcon text={helpText} />}
      </div>
    );
  }
}
